import { NgModule } from '@angular/core';
import { NumberDirective } from './number.directive';
import { StartWithZeroDirective } from './start-with-zero.directive';
import { RunScriptsDirective } from './run-scripts.directive';


@NgModule({
  declarations: [
    NumberDirective,
    StartWithZeroDirective,
    RunScriptsDirective,
  ],
  exports: [
    NumberDirective,
    StartWithZeroDirective,
    RunScriptsDirective,
  ]
})
export class DirectivesModule { }
